import { SystemPermissionDef } from '@juvare/contact-management/backend/features/permissions/shared';

const permissionGroupName = 'Logi reports';

export const logiReportsSystemPermissions = {
    'view-reports': {
        group: permissionGroupName,
        label: 'View Logi Reports',
    },
    'manage-reports': {
        group: permissionGroupName,
        label: 'Manage Logi Reports',
    },
    'administer-report-sources': {
        group: permissionGroupName,
        label: 'Administer Logi Report Sources',
    },
} as const satisfies SystemPermissionDef;
